import classnames from 'classnames';
import { Link as UILink } from 'components/ui';
import { useAnalytics } from 'hooks';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { getBasePathname } from 'utilities/huggg';
import styles from './card.module.scss';

const CardFooter = ({ huggg }) => {
  const analytics = useAnalytics();
  const onTermsClick = useCallback(() => {
    analytics.buttonClickFooterTerms();
  }, [analytics]);

  const links = [
    huggg.id && (
      <RouterLink
        className={styles.linkListLink}
        key={null}
        onClick={onTermsClick}
        to={`${getBasePathname(huggg)}/partner-terms`}
      >
        Terms & Conditions
      </RouterLink>
    ),
    <div className={styles.linkListSeparator} key={null}>
      |
    </div>,
    <UILink.HugggPrivacy className={styles.linkListLink} key={null} />,
  ].filter((_) => _);

  return (
    <nav
      className={classnames(styles.footerNav, 'u-font-smallest')}
      data-test-id="footer-navigation"
    >
      <ul className={styles.linkList}>
        {links.map((link, index) => (
          <li className={styles.linkListItem} key={index}>
            {link}
          </li>
        ))}
      </ul>
    </nav>
  );
};

CardFooter.propTypes = {
  huggg: PropTypes.object.isRequired,
};

export default CardFooter;
